<template>
  <generic-container
    :title="title"
    :icon="icon"
    :header_buttons="hButtons"
    :header_menus="header_menus"
  >
    <slot></slot>
    <editor
      @init="init_code"
      @input="handleInput"
      v-model="content"
      :lang="type"
      :theme="theme"
      ref="editor"
    ></editor>
  </generic-container>
</template>

<script>
import GenericContainer from "@/components/GenericContainer";
import Editor from "vue2-ace-editor";
import { js, css, html } from "js-beautify";

export default {
  name: "CodeEditorIndex",
  components: { GenericContainer, editor: Editor },
  props: {
    header_buttons: {
      type: Array,
      default: function() {
        return [];
      },
    },
    header_menus: {
      type: Array,
      default: function() {
        return [];
      },
    },
    title: { type: String, default: "[DEFAULT_TITLE]" },
    type: { type: String, default: "javascript" },
    theme: { type: String, default: "monokai" },
    icon: { type: String, default: "code" },
    value: { type: String, default: "" },
    show_format: { type: Boolean, default: false },
  },
  data() {
    return {
      content: "",
    };
  },
  computed: {
    hButtons() {
      let vm = this;
      let arr = vm.header_buttons || [];
      if (vm.show_format) {
        arr.push({
          icon: "code",
          tooltip: vm.$t("format code"),
          click: vm.format_code,
        });
      }
      return arr;
    },
  },
  methods: {
    handleInput() {
      this.$emit("input", this.content);
    },
    init_code() {
      if (this.type) {
        require(`brace/mode/${this.type}`);
        require("brace/theme/monokai");
      }
    },
    format_code() {
      let f = undefined;
      if (this.type == "javascript") f = js;
      else if (this.type == "css") f = css;
      else if (this.type == "html") f = html;
      if (f) {
        this.content = f(this.content);
      }
    },
    insert_content(content) {
      this.$refs.editor.editor.session.insert(
        this.$refs.editor.editor.getCursorPosition(),
        content + "\n",
      );

      this.format_code();
    },
  },
  mounted() {
    this.content = this.value;
  },
  watch: {
    value() {
      this.content = this.value;
    },
  },
};
</script>
